import { Injectable, inject } from '@angular/core';
import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
  HttpResponse,
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { LoadingService } from '../services/loading.service';
import { REQUEST_META_DATA } from '@seech/shared-ng';

@Injectable()
export class HttpProgressInterceptor implements HttpInterceptor {
  private requests: HttpRequest<any>[] = [];
  private loadingService = inject(LoadingService);

  constructor() {}

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    // Check if progress should be skipped for this request
    if (
      req.context.get(REQUEST_META_DATA.ALL) !== true &&
      req.context.get(REQUEST_META_DATA.PROGRESS) !== true
    ) {
      this.requests.push(req);
      // Show progress indicator when first request starts
      if (this.requests.length === 1) {
        this.loadingService.isLoading.next(true);
      }
    }

    return new Observable((observer: any) => {
      const subscription = next.handle(req).subscribe({
        next: (event) => {
          if (event instanceof HttpResponse) {
            observer.next(event);
          }
        },
        error: (err) => {
          observer.error(err);
        },
        complete: () => {
          this.removeRequest(req);
          observer.complete();
        },
      });

      // Remove request from queue when cancelled
      return () => {
        this.removeRequest(req);
        subscription.unsubscribe();
      };
    });
  }

  private removeRequest(req: HttpRequest<any>) {
    if (
      req.context.get(REQUEST_META_DATA.ALL) !== true &&
      req.context.get(REQUEST_META_DATA.PROGRESS) !== true
    ) {
      const i = this.requests.indexOf(req);
      if (i >= 0) {
        this.requests.splice(i, 1);
      }

      // Hide progress indicator when all requests complete
      if (this.requests.length === 0) {
        this.loadingService.isLoading.next(false);
      }
    }
  }
}
